import {crashlytics} from '../crashlytics';
import {CrashlyticsLogicError} from './exceptions';

/**
 *
 * @param error
 * @returns
 */
export const handleError = (
  error: unknown | Error,
  status: string,
  source?: string,
) => {
  if ((error as Error).name === 'RemoteCallError') {
    return;
  }
  recordError(
    `Error processing state or service response.  Status (${status}).  Source (${source})`,
  );
};

export const handleLoginCredentialsFail = () => {
  recordError('Credentials failed on login.  ');
};

const recordError = (message: string) => {
  crashlytics().recordError(new CrashlyticsLogicError(`${message}`));
  crashlytics().sendUnsentReports();
};
